import { compose } from "@insightfulscience/shared-utils/fn";
import Emitter from "@insightfulscience/shared-utils/Emitter";

const SUCCESS = "success";
const ERROR = "error";

const addHandler = (emitter, suffix) => (operationName, callback) =>
	emitter.on(`${operationName}::${suffix}`, callback);

const notify = emitter => (operationName, variables, { errors, data }) => {
	try {
		emitter.notify(
			`${operationName}::${errors ? ERROR : SUCCESS}`, //
			variables,
			errors ? (errors && errors[0]) || errors : data[operationName],
		);
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error("", err.message);
	}
};

const eventsApi = emitter => ({
	on: addHandler(emitter, SUCCESS),
	onError: addHandler(emitter, ERROR),
	notify: notify(emitter),
});

export const ApolloEvents = compose(eventsApi, Emitter);
